module.exports = __webpack_public_path__ + "static/DEV2-ee602ea8411f9f4b4f3a91ba7b5af64b.png";